import { useState, useEffect, useRef, useCallback } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import axiosPrivate from "../../hooks/axiosPrivate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MdFormatListBulleted, MdApps } from "react-icons/md";
import { Apps, FormatListBulleted, ListAltOutlined } from "@mui/icons-material";
import StickerTemplate from "./StickerTemplate";
import { FaPrint } from "react-icons/fa6";
import { showErrorToast, showSuccessToast } from "../../utils/Toaster";
export default function StickersForm() {
  const [isCreating, setIsCreating] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [manualSO, setManualSO] = useState(false);
  const [soNumber, setSONumber] = useState("");
  const [manualSOValue, setManualSOValue] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerDisabled, setCustomerDisabled] = useState(false);
  const [boxNumber, setBoxNumber] = useState("01/01");
  const [stickerData, setStickerData] = useState("");
  const [soDetails, setSODetails] = useState(null);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("sticker-view") || "list"
  );
  useEffect(() => {
    try {
      localStorage.setItem("sticker-view", viewMode);
    } catch (e) {
      console.error("Failed to save view mode to localStorage:", e);
    }
  }, [viewMode]);

  const [quantity, setQuantity] = useState("");

  const fetchSalesOrder = async (
    inputValue = "",
    loadedOptions = [],
    { page = 1 } = {}
  ) => {
    try {
      const response = await axiosPrivate.post(
        `/job/sales_order?page=${page}&offset=20&search=${inputValue}`,
        {
          page,
          offset: 20,
          search: inputValue || "",
        }
      );
      const data = response?.data?.data || [];
      const hasMore = data.length === 20;
      return {
        options: data.map((SO) => ({ value: SO, label: SO })),
        hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page + 1,
        },
      };
    }
  };

  const fetchSalesOrderDetails = async (OrderNum) => {
    try {
      const response = await axiosPrivate.get(
        `/dashboard/get_sticker_details`,
        {
          params: { so_number: OrderNum },
        }
      );
      setSODetails(response?.data?.data || null);
      return response?.data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const createSticker = async () => {
    if (isCreating) return;
    setIsCreating(true);
    try {
      const payload = {
        data: {
          sales_order: manualSO ? manualSOValue : soNumber,
          customer_name: customerName,
          quantity: Number(quantity),
          box_no: boxNumber,
        },
      };

      const response = await axiosPrivate.post(
        "/dashboard/create_stickers",
        payload
      );
      console.log(response);
      if (response.status === 201) {
        setStickerData(response.data.data);
        showSuccessToast("Sticker Created Successfully");
      } else {
        showErrorToast("Failed to create sticker");
      }
      setSONumber("");
      setManualSOValue("");
      setCustomerName("");
      setQuantity("");
      setBoxNumber("01/01");
    } catch (error) {
      console.error("Error creating sticker:", error);
    } finally {
      setIsCreating(false);
    }
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const debouncedFilterChange = useCallback(
    debounce(async (value) => {
      if (!value.trim().length) {
        setSODetails(null);
        return;
      }
      try {
        const response = await axiosPrivate.get(
          `/dashboard/get_sales_order_list`,
          {
            params: { so_number: value },
          }
        );
        setSODetails(response?.data?.data || null);
        return response?.data || null;
      } catch (error) {
        console.error(error);
        return null;
      }
    }, 1000),
    []
  );

  const handlePrint = async (sticker) => {
    if (isPrinting) return;
    setIsPrinting(true);
    try {
      const printData = sticker || {
        sales_order: manualSO ? manualSOValue : soNumber,
        customer_name: customerName,
        quantity: Number(quantity),
        box_no: boxNumber,
      };

      const response = await fetch("http://localhost:3003/print", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(printData),
      });

      const result = await response.json();
      console.log("Print result:", result);
      if (result.success) {
        showSuccessToast("Print command sent successfully!");
      } else {
        showErrorToast("Failed to print: " + (result.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error printing:", error);
      showErrorToast("Error printing: " + error.message);
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <div className={`content sticker-view-${viewMode}`}>
      <div className="d-flex flex-column">
        <div className="page-header px-2 bg-white">
          <h3 className="page-title">Dispatch Stickers</h3>
        </div>
        <div
          className="filter-section col-12 d-flex flex-column rounded-3 p-2"
          style={{
            border: "1px solid #dee2e6",
            backgroundColor: "#f8f9fa",
          }}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center row mb-2">
            <div className="form-group col-md mb-3">
              <label
                className="form-label"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>
                  Sales Order <span style={{ color: "#ff5252" }}>*</span>
                </span>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    marginBottom: 0,
                    color: "#ff5252",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={manualSO}
                    onChange={(e) => {
                      setManualSO(e.target.checked);
                      setCustomerName("");
                      setQuantity("");
                      setBoxNumber("01/01");
                      setCustomerDisabled(false);
                      setSONumber("");
                    }}
                    style={{ accentColor: "#ff5252" }}
                  />
                  <span style={{ cursor: "pointer" }}>Enter Manually</span>
                </label>
              </label>

              {manualSO ? (
                <input
                  type="number"
                  className="form-control mt-2"
                  placeholder="Enter Sales Order Number"
                  value={manualSOValue}
                  onChange={(e) => {
                    setManualSOValue(e.target.value);

                    debouncedFilterChange(e.target.value);
                  }}
                />
              ) : (
                <AsyncPaginate
                  className="mt-2"
                  placeholder="Search Sales Order"
                  loadOptions={fetchSalesOrder}
                  onChange={async (selectedOption) => {
                    if (selectedOption) {
                      setSONumber(selectedOption.value);
                      const details = await fetchSalesOrderDetails(
                        selectedOption.value
                      );
                      setCustomerName(details?.data?.CustomerName || "");
                      setQuantity(details?.data?.total_quantity || "");
                      setCustomerDisabled(!!details);
                      setBoxNumber("01/01");
                    } else {
                      setCustomerName("");
                      setQuantity("");
                      setSONumber("");
                      setBoxNumber("01/01");
                      setCustomerDisabled(false);
                    }
                  }}
                  value={soNumber ? { value: soNumber, label: soNumber } : ""}
                  isClearable
                  debounceTimeout={1000}
                  additional={{
                    page: 1,
                  }}
                />
              )}
            </div>

            <div className="form-group col-md mb-3">
              <label className="form-label">
                Box no.<span style={{ color: "#ff5252" }}>*</span>
              </label>
              <input
                type="text"
                value={boxNumber}
                onChange={(e) => setBoxNumber(e.target.value)}
                className="form-control"
                placeholder="Enter Box no."
              />
            </div>

            <div className="form-group col-md mb-3">
              <label className="form-label">
                Quantity<span style={{ color: "#ff5252" }}>*</span>
              </label>
              <input
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="form-control"
                placeholder="Enter Quantity"
              />
            </div>

            <div className="form-group col-md mb-3">
              <label className="form-label">
                Customer name<span style={{ color: "#ff5252" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Customer name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                disabled={customerDisabled}
              />
            </div>

            <div className="d-flex justify-content-end align-items-center mt-2 col-auto">
              <button
                className="btn btn-primary"
                onClick={() => {
                  createSticker();
                }}
                style={{ marginRight: "10px" }}
                disabled={
                  isCreating ||
                  !(
                    (manualSO ? manualSOValue : soNumber) &&
                    quantity &&
                    boxNumber &&
                    customerName
                  )
                }
              >
                Create
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  handlePrint();
                }}
                style={{ marginRight: "10px" }}
                disabled={
                  isPrinting ||
                  !(
                    (manualSO ? manualSOValue : soNumber) &&
                    quantity &&
                    boxNumber &&
                    customerName
                  )
                }
              >
                Print
              </button>
            </div>
          </div>
        </div>

        <div className="table-responsive jobs-tab px-2">
          {soDetails && (
            <div
              style={{
                margin: "8px 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <strong>SO:</strong> {soDetails.OrderNum} &nbsp; &nbsp; &nbsp;
                <strong>Customer:</strong> {soDetails.CustomerName}
              </div>
              <div>
                <button
                  className={`btn btn-sm ${
                    viewMode === "list" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={() => setViewMode("list")}
                >
                  <FormatListBulleted />
                </button>
                <button
                  className={`btn btn-sm ${
                    viewMode === "cards" ? "btn-primary" : "btn-light"
                  }`}
                  style={{ marginLeft: 8 }}
                  onClick={() => setViewMode("cards")}
                >
                  <Apps />
                </button>
              </div>
            </div>
          )}

          {soDetails &&
          Array.isArray(soDetails.sticker_details) &&
          soDetails.sticker_details.length > 0 ? (
            viewMode === "list" ? (
              <DataTable
                value={soDetails.sticker_details}
                scrollable
                scrollHeight="60vh"
                className="p-datatable-sm"
              >
                <Column
                  field="serial_number"
                  header="S.No."
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                />
                <Column field="box_no" header="Box No." />
                <Column field="quantity" header="Quantity" />
                <Column
                  field="created_at"
                  header="Created At"
                  body={(row) => new Date(row.created_at).toLocaleString()}
                />
                <Column
                  field="action"
                  header="Action"
                  body={(row) => (
                    <FaPrint
                      style={{ cursor: "pointer", color: "#ff5252" }}
                      onClick={() => handlePrint(row)}
                    />
                  )}
                />
              </DataTable>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))",
                  gap: 20,
                }}
              >
                {soDetails.sticker_details.map((st) => (
                  <StickerTemplate key={st.id} sticker={st}  onPrint={handlePrint} />
                ))}
              </div>
            )
          ) : (
            <div style={{ padding: 12, color: "#666" }}>
              No sticker details to show.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
